import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationPin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M1 2.7c-2.8 4.5.9 9.8 5 13.3 4.1-3.5 7.8-8.8 5-13.3A5.5 5.5 0 006 0C3.5 0 2 1.1 1 2.7zM6 8a2 2 0 100-4 2 2 0 000 4z"
	})
});
export default SvgLocationPin;
